import { app, googleAuthProvider } from '@BUP/configs/Firebase';

export const firebaseSignIn = (email, password) => {
  return app
    .auth()
    .signInWithEmailAndPassword(email, password)
};

export const firebaseSignUp = (email, password) => {
  return app
    .auth()
    .createUserWithEmailAndPassword(email, password)
};

export const firebaseSignInProvider = (provider) => {
  if (provider === 'google') {
    return app
      .auth()
      .signInWithPopup(googleAuthProvider)
  }

};

export const firebaseSignOut = () => {
  return app
    .auth()
    .signOut()
};

export const firebaseSendPasswordResetEmail = email => {
  return app
    .auth()
    .sendPasswordResetEmail(email)
    .then(() => {
      return true;
    });
};

export const firebaseConfirmPasswordReset = (code, password) => {
  return app
    .auth()
    .confirmPasswordReset(code, password)
    .then(() => {
      return true;
    });
};

export const firebaseGetCurrentUserToken = () => {
  return app
    .auth()
    .currentUser
    .getIdToken();
}

export const firebaseGetCurrentUser = () => {
  return app
    .auth()
    .currentUser;
}

export const firebaseDeleteCurrentUser = async () => {
  console.log("firebaseDeleteCurrentUser")
  let user = await firebaseGetCurrentUser();
  return user
    .delete();

}

export const firebaseRestorePassword = async (emailAddress) => {
  return app
    .auth()
    .sendPasswordResetEmail(emailAddress)
}

// export const firebaseOnAuthStateChange = async (cb) => {
//   return app
//     .auth()
//     .onAuthStateChanged(user => {
//       if (user) {
//         const token = firebaseGetCurrentUserToken();
//         console.log(token)
//         if(token) {
//           axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
//         }
//         cb(user);
//       } else {
//         axios.defaults.headers.common['Authorization'] = null;
//         cb(null);
//       }
//     });
// }